import { Sun, Moon, Monitor } from 'lucide-react';
import { type Theme, type ResolvedTheme } from '../../store/theme';

interface ThemeIconProps {
  theme?: Theme;
  resolvedTheme?: ResolvedTheme;
  className?: string;
  size?: number;
}

export const ThemeIcon = ({ 
  theme, 
  resolvedTheme, 
  className = "h-4 w-4",
  size 
}: ThemeIconProps) => {
  // If theme is provided, use it to determine icon
  if (theme) {
    switch (theme) {
      case 'light':
        return <Sun className={className} size={size} />;
      case 'dark':
        return <Moon className={className} size={size} />;
      case 'system':
        return <Monitor className={className} size={size} />;
      default:
        return <Sun className={className} size={size} />;
    }
  }
  
  // If only resolvedTheme is provided, show light/dark icon
  if (resolvedTheme) {
    return resolvedTheme === 'dark' 
      ? <Moon className={className} size={size} />
      : <Sun className={className} size={size} />;
  }
  
  // Default fallback
  return <Sun className={className} size={size} />;
}; 